import React from 'react';


import Inicio from '../Inicio';
// import '../../style.css';

function Home(){
    return(
        <div>
            <Inicio/>
        </div>
    );
}

export default Home;